import React, { useState, useEffect } from 'react';
import './DetailStory.scss';
import Layout from '../Layout/Layout';
import hackernews from '../../api/hackernews';
import HashLoader from 'react-spinners/HashLoader';
import StoryItem from '../StoryItem/StoryItem';
import CommentItem from '../CommentItem/CommentItem';

const DetailStory = (props) => {
  const { match } = props;
  const [story, setStory] = useState(null);
  const [isLoadingComments, setIsLoadingComments] = useState(true);
  const [comments, setComments] = useState([]);

  useEffect(() => {
    const getStory = async () => {
      try {
        const res = await hackernews.get(`/item/${match.params.id}.json`);
        setStory(res.data);
      } catch (err) {
        console.log(err);
      }
    };
    getStory();
  }, [match.params.id]);

  useEffect(() => {
    const getComments = async () => {
      setIsLoadingComments(true);
      try {
        let _data = [];
        const { kids } = story;
        if (kids) {
          const max = kids.length > 30 ? 30 : kids.length;
          for (let i = 0; i < max; i++) {
            const res = await hackernews.get(`/item/${kids[i]}.json`);
            _data.push(res.data);
          }
        }
        setIsLoadingComments(false);
        setComments(_data);
      } catch (err) {
        console.log(err);
      }
    };
    if (story) {
      getComments();
    }
  }, [story]);

  return (
    <Layout>
      {isLoadingComments ? (
        <div className="loading-container">
          <HashLoader size={50} color={'#ff6600'} loading={isLoadingComments} />
        </div>
      ) : (
        <>
          {!story ? (
            <h1>Sorry, story doesn't exist</h1>
          ) : (
            <div>
              <StoryItem story={story} idx={-1} type={match.params.type} />
              {story.text && (
                <p
                  dangerouslySetInnerHTML={{ __html: story.text }}
                  className="story-text"
                ></p>
              )}
              <div className="comments-container">
                <p className="comment-discussion">Discussions:</p>
                {comments.length > 0 ? (
                  <>
                    {comments.map((comment) => {
                      return <CommentItem comment={comment} key={comment.id} />;
                    })}
                  </>
                ) : (
                  <p>There is no comment.</p>
                )}
              </div>
            </div>
          )}
        </>
      )}
    </Layout>
  );
};

export default DetailStory;
